import script from "./SectionHorizontalStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionHorizontalStrip.vue?vue&type=script&setup=true&lang=js"

import "./SectionHorizontalStrip.vue?vue&type=style&index=0&id=561fd8fa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561fd8fa"]])

export default __exports__